import React from 'react';
import classNames from 'classnames';
import { animateScroll as scroll } from 'react-scroll';

import { centeredLogos } from './styles';
import { Link } from '@paypalcorp/pp-react';

export default class extends React.Component {
  handleLogoScroll = (event) => {
    event.preventDefault();
    scroll.scrollTo(
      document.getElementById(this.refs.logoScroll.hash.slice(1)).offsetTop - 50
    );
  };

  render() {
    let logoUrls =
      this.props.campaignInfo.templateData.navAndLogoStrip.logoUrls &&
      this.props.campaignInfo.templateData.navAndLogoStrip.logoUrls.split(',');
    let charities = (this.props.campaignInfo.charities || []).filter((c) => {
      return !!c;
    });

    let keyId;

    let logos = [];

    let imageStyleSingleCharity = classNames('imageStyle', {
      singleCharity: this.props.numCharities === 1,
      navigationOff: this.props.navNeeded === 'no',
    });

    let imageStyle = classNames('imageStyle', {
      navigationOff: this.props.navNeeded === 'no',
    });

    let imageShowSingleCharity = classNames('imageShow', {
      singleCharity: this.props.numCharities === 1,
      navigationOff: this.props.navNeeded === 'no',
      uploadedImage: this.props.campaignInfo.templateData.navAndLogoStrip
        .logoUrls,
    });

    let imageShow = classNames('imageShow', {
      navigationOff: this.props.navNeeded === 'no',
    });

    let logosSingleCharity = classNames('logos', {
      singleCharity: this.props.numCharities === 1,
      navigationOff: this.props.navNeeded === 'no',
    });

    let max;
    if (logoUrls) {
      max = logoUrls.length < 7 ? logoUrls.length : 6;
      for (let i = 0; i < max; i++) {
        keyId = 'key_' + i;
        logos.push(
          <div key={keyId} className={imageStyleSingleCharity}>
            <Link ref='logoScroll' className='scrollLink'>
              <img className={imageShowSingleCharity} src={logoUrls[i]} />
            </Link>
          </div>
        );
      }
    } else if (charities) {
      max = charities.length < 7 ? charities.length : 6;
      for (let i = 0; i < max; i++) {
        keyId = charities[i].shared_nonprofit_id;
        logos.push(
          <div key={keyId} className={imageStyle}>
            <Link
              ref='logoScroll'
              onClick={this.handleLogoScroll}
              className='scrollLink'
              href='#chooseCharities'
            >
              <img
                className={imageShow}
                src={charities[i].logo_url}
                alt={`${charities[i].name}`}
              />
            </Link>
          </div>
        );
      }
    }
    // picking up from styles.js for centering logo in single charity case
    let logoStyling =
      (charities && charities.length === 1) ||
      (logoUrls && logoUrls.length === 1)
        ? Object.assign({}, centeredLogos)
        : {};

    return (
      <div
        className={logosSingleCharity}
        style={this.props.isFixed ? { marginTop: '50px' } : {}}
      >
        <div className='borderBottom' style={logoStyling}>
          {logos}
        </div>
      </div>
    );
  }
}
